<template>
  <div>
    <el-button @click="add">费用收付</el-button>
    <el-button @click="paidsSelect">已缴款</el-button>
    <el-button @click="invoicin">票据查询</el-button>
    <el-button @click="order">打开应收费用缴款</el-button>
    <el-button @click="$emit('top')">返回</el-button>
    <div>
      <div>
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item  label="查询房产/客户">
              <el-autocomplete
                v-model="house_name"
                size="mini"
                style="width: 100%;"
                :fetch-suggestions="querySearchAsync"
                placeholder="可搜索房产/客户姓名"
                clearable
                @select="handleSelect"
              ></el-autocomplete>
            </el-descriptions-item>
            <el-descriptions-item>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
          <el-descriptions-item  label="客户名称">
            <div style="display: flex;">
              <div style="color:green;width: 60%;">{{select.name.name}}</div>
              <div style="color: red;width: 40%;text-align: right;cursor: pointer;" @click="user">选择收费客户</div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="房产信息">
            <div style="color:green;">{{select.house}}</div>
          </el-descriptions-item>
          <el-descriptions-item  label="缴费日期">
            <div v-if="ERP.isPermission(4003007011)">
              <el-date-picker v-model="select.date" type="datetime" size="mini" style="width: 100%;" placeholder="缴费日期"></el-date-picker>
            </div>
            <div v-else>
              <el-date-picker v-model="select.date" type="datetime" size="mini" style="width: 100%;" placeholder="缴费日期" :disabled="true"></el-date-picker>
            </div>
          </el-descriptions-item>
          <el-descriptions-item  label="结算方式">
            <RadioGroup v-model="select.pay">
              <div style="display: flex;flex-wrap: wrap;">
                <div v-for="it in dataPay" :key="it.id">
                    <Radio :label="it.number">{{it.name}}</Radio>
                </div>
              </div>
            </RadioGroup>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="margin-top: 5px;"></div>
      <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" height="49vh"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column  label="房产" width="400">
          <template slot-scope="scope">
            <div style="display: flex;width: 100%;">
              <div style="width: 56px;">
                <el-tooltip v-if="scope.row.type == 2" class="item" effect="dark" content="选择收费房间" placement="top">
                  <img @click="houses(scope.$index)" style="width: 20px;height: 20px;cursor: pointer;" src="../../../../../static/home.png"/>
                </el-tooltip>
                <el-tooltip v-if="scope.row.del==1" class="item" effect="dark" content="向下复制行(用于同时缴纳多个收费周期)" placement="top">
                  <img @click="cps(scope.row.type,tableData[scope.$index])" style="width: 20px;height: 20px;cursor: pointer;" src="../../../../../static/navber.png"/>
                </el-tooltip>
                <el-tooltip v-else class="item" effect="dark" content="删除" placement="top">
                  <img @click="del(scope.$index)" style="width: 20px;height: 20px;cursor: pointer;" src="../../../../../static/delete.png"/>
                </el-tooltip>
              </div>
              <div>{{scope.row.h_name_date}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column  label="收费标准" width="230">
          <template slot-scope="scope">
            <div style="display: flex;">
              <el-input size="mini" placeholder="" v-model="tableData[scope.$index].charge"></el-input>
              <el-tooltip class="item" effect="dark" content="选择收费标准" placement="top" style="margin-left: 3px;margin-top: 3px;">
                <img @click="charge_select(scope.row.pid,scope.$index)" style="width: 20px;height: 20px;cursor: pointer;" src="../../../../../static/menu.png"/>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="费用周期" width="310">
          <template slot-scope="scope">
            <el-date-picker type="date" v-model="tableData[scope.$index].startDate" size="mini" style="width: 129px;" placeholder="开始日期"></el-date-picker>
            <span style="margin-left: 1px;margin-right: 1px;">至</span>
            <el-date-picker type="date" v-model="tableData[scope.$index].endDate" size="mini" style="width: 129px" placeholder="结束日期"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="金额" width="130">
          <template slot-scope="scope">
            <el-input size="mini" placeholder="收款金额" v-model="tableData[scope.$index].monery"></el-input>
          </template>
        </el-table-column>
        <el-table-column  label="摘要" width="300">
          <template slot-scope="scope">
            <el-input type="textarea" v-model="tableData[scope.$index].remark" placeholder="摘要"></el-input>
          </template>
        </el-table-column>
        <el-table-column  label="选择装修" width="300">
          <template slot-scope="scope">
            <el-select style="width: 100%" v-model="tableData[scope.$index].fitment_id" filterable placeholder="选择装修" class="kuan">
              <el-option v-for="item in fitment_list" :key="item.ID" :label="item.FitmentID" :value="item.ID"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="仪表" width="150">
          <template slot-scope="scope">
            <div style="display: flex;">
              <el-input placeholder="" v-model="tableData[scope.$index].meter" size="mini" :disabled="true"></el-input>
              <el-tooltip class="item" effect="dark" content="选择仪表" placement="top" style="margin-left: 3px;margin-top: 3px;">
                <img @click="meter" style="width: 20px;height: 20px;cursor: pointer;" src="../../../../../static/clock.png"/>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="票据号码" width="80">
          <template slot-scope="scope">
            自动
          </template>
        </el-table-column>

      </el-table>
      <!-- 弹窗选择用户 -->
      <Modal
        v-model="modal1"
        width="800"
        title="选择客户"
        @on-ok="roomUser">
        <div>
          <room-user style="height: 600px;" ref="child" :house="house_1"></room-user>
        </div>
      </Modal>
      <house ref="house"></house>
      <charge ref="charges" @chargeAdd='chargeAdd'></charge>
      <!-- 打印 -->
      <prints ref="ref"></prints>
      <!-- 已付款 -->
      <paids ref="paid"></paids>
      <!-- 票据查询 -->
      <InvoicingSelect ref="invo_select"></InvoicingSelect>
    </div>
  </div>
</template>

<script>
  export default {
      data () {
        return {
          house_1:'',
          modal1:false,
          house_name:'',
          dataPay:[],
          data:[],
          select:{
            pay:'1',
            house:'',
            name:{'name':'','id':''},
            date:'',
            startDate:'',
            endDate:'',
            chargeitemID:[],
            pid:''
          },
          fitment_list:[],
          tableData:[],
          charge_index:''
        }
      },
      components: {
        "room-user": () => import('../../Common/room-user.vue'),
        "house": () => import('../../Flow/components/SelectProjectHouse.vue'),
        "charge": () => import('./charge.vue'),
        "paids": () => import('../order/paids.vue'),
        "InvoicingSelect": () => import('../order/InvoicingSelect.vue'),
        "prints": () => import('../order/prints.vue'),
      },
      mounted(){
        let house = window.localStorage.getItem('house');
        let project_id = window.localStorage.getItem('project_id');
        this.select.house = house;
        this.select.pid = project_id;
        this.tableDatas(project_id,house);
        //加载收款方式
        this.$myhttp.get('admin/OrderPayment/index',{
          'Content-Type': 'application/json'
          }).then(backdata=>{
              let dataPay = backdata.data.data;
              this.dataPay = dataPay;
              this.select.date = backdata.data.date;
              this.select.pay = dataPay[0]['number']
        });
      },
      //事件
      methods: {
        //已缴款查询
        paidsSelect(){
          let data = {'date':this.tableData[0].startDate,'house':this.select.house}
          let house = [{'id':this.tableData[0].house_id,'house':this.select.house}]
          this.$refs.paid.getInvo(data,house,this.dataPay,this.select.name);
        },
        //打开应收费用
        order(){
           window.open("/#/order/order", '_blank');
        },
        //票据查询
        invoicin(){
          let data = {'date':this.tableData[0].startDate,'house':this.select.house}
          let house = [{'id':this.tableData[0].house_id,'house':this.select.house}]
          this.$refs.invo_select.getInvo(data,house);
        },
        //收费项
        chargeAdd(){
          let charge = this.$refs.charges.treeRetrue();
          this.tableData[this.charge_index].charge = charge.label;
          this.tableData[this.charge_index].charge_list = charge;
        },
        //费用收付
        add(){
          this.$confirm('确定要收付吗', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let data = {'data':this.data,'select':this.select};
            this.$myhttp.post("admin/Temporary/addCharge", data, {
                "Content-Type": "application/x-www-form-urlencoded",
            }).then((backdata) => {
              if(backdata.data.code==200){
                this.$Message.success(backdata.data.message);
                this.tableDatas('',this.data[0].h_name_date);
                this.prin(backdata.data.id,0,backdata.data.pid);
              }else{
                this.$Message.error(backdata.data.message);
              }
            });
          })
        },
        //选择客户
        roomUser(){
          let user = this.$refs.child.getUser();
          if(user.id){
            this.select.name = user;
          }
        },
        user(){
          this.modal1 = true;
        },
        //选择房间
        houses(index){
          let _this = this;
          this.$refs.house.show([],function(data){
            let datas = {'house':data.tree_str}
            this.$myhttp.post("admin/Temporary/house", datas, {
                "Content-Type": "application/x-www-form-urlencoded",
            }).then((backdata) => {
                let data = backdata.data.data[0];
                _this.tableData[index].h_name_date = data.ancestor_name;
                _this.tableData[index].pid = data.erp_pindex_id;
                _this.tableData[index].house_id = data.erp_house_id;
            });


          });
        },
        //选择收费标准
        charge_select(pid,index){
          this.charge_index = index;
          this.$refs.charges.getInvo(pid);
        },
        //搜索选中
        handleSelect(item) {
          this.select.house = item.value;
          this.tableDatas('',item.value);
        },
        //远程搜索方式
        querySearchAsync(query, cb) {
          if (query !== '') {
            this.loading_dade = 2;
            this.$myhttp.get('admin/common/house_name?house_name='+query,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.loading_dade = 1;
                this.selectList = backdata.data.data;
                let value = [];
                this.selectList.map(req=>{
                  value.push({'value':req.house})
                })
                cb(value)
            });
          }
        },
        //选中
        handleSelectionChange(val) {
          this.data = val;
        },
        meter(){
          this.$Message.error("此房间未设置仪表");
        },
        //项目id
        pids(pid,tree_str){
          this.select.house = tree_str;
          this.select.pid = pid;
          this.tableDatas(pid,tree_str);
        },
        tableDatas(pid,tree_str){
          let datas = {'house':tree_str}
          this.$myhttp.post("admin/Temporary/house", datas, {
              "Content-Type": "application/x-www-form-urlencoded",
          }).then((backdata) => {
              if(backdata.data.customer != ''){
                this.select.name = backdata.data.customer[0];
              }else{
                this.select.name = {'name':''};
              }
              let date = backdata.data.date;
              let data = backdata.data.data[0];
              this.tableData = [
                {'pid':data.erp_pindex_id,'house_id':data.erp_house_id,'h_name_date':data.ancestor_name,'type':1,'meter':'','charge':'','startDate':date,'endDate':date,'remark':'','monery':'','fitment_id':'','del':1},
                {'pid':'','house_id':'','h_name_date':'','type':2,'meter':'','charge':'','startDate':date,'endDate':date,'remark':'','monery':'','fitment_id':'','del':1}
              ];
              this.toggleSelection1();
              if(data.erp_house_id != ''){
                this.getFitmentList(data.erp_house_id)
              }
          });
        },
        getFitmentList(hid) {
          this.$myhttp.get('admin/Deposit/getFurnishSelect?house_id=' + hid, {
            'Content-Type': 'application/json'
          }).then(backdata => {
            if (backdata.data.code == 1) {
              this.fitment_list = backdata.data.data
              // console.log(this.fitment_list)
            }
          });
        },
        //复制
        cps(type,data){
          let datas = JSON.parse(JSON.stringify(data));
          datas.del=2;
          let list = [];
          list.push(this.tableData[0]);
          if(type == 1){
            list.push(datas);
            this.tableData.map((red,indexs)=>{
              if(indexs != 0){
                list.push(red);
              }
            })
            this.tableData = list;
            this.toggleSelection();
          }
          if(type == 2){
            this.tableData.push(datas);
          }
        },
        //删除
        del(index){
          let data = [];
          this.tableData.map((red,indexs)=>{
            if(index != indexs){
              data.push(red);
            }
          })
          this.tableData = data;
          this.toggleSelection();
        },
        //默认选中
        toggleSelection(){
          let _this = this;
          setTimeout(function(){
            _this.tableData.forEach(row => {
              if(row.type != 2){
                console.log(369369369)
                _this.$refs.multipleTable.toggleRowSelection(row);
              }
            });
          },50)
        },
        toggleSelection1(){
          let _this = this;
          setTimeout(function(){
            _this.tableData.forEach(row => {
              if(row.type != 2){
                console.log(369369369)
                _this.$refs.multipleTable.toggleRowSelection(row);
              }
            });
          },1000)
        },
        prin(id,money,pid){
          this.$refs.ref.getPrints(id,money,pid);//调用子组件打印336470
        },
      }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/temporary/add.vue